import { apiRequest } from "@/services/api-client";

export interface LeaderboardEntry {
  rank: number;
  username: string;
  score: number;
  user_id: string;
  country?: string;
}

export interface LeaderboardData {
  season: number;
  remaining_days: number;
  entries: LeaderboardEntry[];
  current_user_entry?: LeaderboardEntry;
}

/**
 * Fetches leaderboard rankings
 */
export const getLeaderboard = () =>
  apiRequest<LeaderboardData>("/leaderboard");
